/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */
import { Injectable } from '@angular/core';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

// locals
import { ApiResponse, mockSuccessResponse } from '@models/api-response.model';
import { ApiService } from 'app/services/api.service';
import { Cluster } from '@core/models';
import { BaseStorageKeys, BaseStorageService, PREFIXES } from './base-storage.service';
import { environment } from 'environments/environment';
import { MOCK_CLUSTER_LIST } from '@core/mocks/mock-services';
const USE_MOCK_SERVICES = (environment as { useMockServices?: boolean }).useMockServices ?? false;

@Injectable({
  providedIn: 'root',
})
export class ClusterService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private baseStorageService: BaseStorageService
  ) {}

  getClusters(): Observable<ApiResponse<Cluster[]>> {
    if (USE_MOCK_SERVICES) {
      return of(mockSuccessResponse(MOCK_CLUSTER_LIST));
    }
    return this.http
      .get<ApiResponse>(`${this.apiService.clusters}/`)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  createCluster(payload: any): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(`${this.apiService.clusters}/`, payload)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  updateCluster(payload: any): Observable<ApiResponse<Cluster>> {
    return this.http
      .put<ApiResponse>(`${this.apiService.clusters}/${payload.id}`, payload)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }

  async setCurrentCluster(cluster: Cluster): Promise<void> {
    this.baseStorageService.set(BaseStorageKeys.Cluster, cluster, PREFIXES.EMPTY);
  }

  updateCurrentCluster(payload: Cluster): void {
    this.baseStorageService.set(BaseStorageKeys.Cluster, payload, PREFIXES.EMPTY);
  }

  get currentCluster(): Cluster {
    return this.baseStorageService.get<any>(BaseStorageKeys.Cluster, PREFIXES.EMPTY);
  }
}
